import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import QuestionDisplay from './QuestionDisplay';

type PracticalQuestionType = React.ComponentProps<typeof QuestionDisplay>['questionType'];

interface PracticalAssessmentProps {
  practicalType: NonNullable<PracticalQuestionType>;
  title?: string;
  questionTag?: string;
}

/** Shared assessment block to keep seeded practical questions alongside every lab. */
const PracticalAssessment: React.FC<PracticalAssessmentProps> = ({ practicalType, title = 'Assessment Question', questionTag }) => (
  <Paper component="section" aria-label={`${title} for ${practicalType}`} elevation={0} sx={{ my: 2, overflow: 'hidden', border: '1px solid rgba(25, 118, 210, .45)', borderRadius: 2 }}>
    <Box sx={{ px: 2, py: 1, backgroundColor: 'rgba(25, 118, 210, .08)' }}>
      <Typography variant="subtitle1" fontWeight={800}>{title}</Typography>
      <Typography variant="caption" color="text.secondary">Practice and submit this experiment-specific question before leaving the practical.</Typography>
    </Box>
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <QuestionDisplay labMode="practice" questionType={practicalType} qualitativeTag={questionTag} />
    </Box>
  </Paper>
);

export default PracticalAssessment;
